import { useOptimizelyFlagContext } from '@/scopes/common/infrastructure/ab-testing/optimizely/useOptimizely'
import { mqMin, space, tok, tokPx } from '@sunwebgroup/ui-components'

import * as React from 'react'

import { css, styled } from 'styled-components'
import { Filters } from './Filters'
import { SelectedFiltersTokens } from './SelectedFiltersTokens'

const Wrapper = styled.aside<{ $splitDetailsEnabled: boolean }>`
  display: none;
  align-self: start;
  padding: ${space('primitives_space_24')};
  min-width: 0;
  border-radius: ${tokPx('semantics_boxes_corner_radius')};
  background-color: ${tok('semantics_views_background_color')};
  border: ${tokPx('semantics_boxes_border_width')} solid ${tok('semantics_boxes_border_color')};

  ${({ $splitDetailsEnabled }) =>
    $splitDetailsEnabled
      ? css`
        @media (min-width: 1280px) {
          display: initial;
        }
      `
      : css`
        @media ${mqMin('primitives_breakpoint_l_min')} {
          display: initial;
        }
      `}
`

const DesktopOnly = styled.div`
  display: none;
  @media ${mqMin('primitives_breakpoint_l_min')} {
    display: initial;
  }
`

export function SideBar() {
  const { productCardSplitDetails } = useOptimizelyFlagContext()
  return (
    <Wrapper $splitDetailsEnabled={productCardSplitDetails}>
      <DesktopOnly>
        <SelectedFiltersTokens withResetButton />
      </DesktopOnly>
      <Filters />
    </Wrapper>
  )
}
